import { Capacitor } from "@capacitor/core";

export const isNative = () => Capacitor.isNativePlatform();

export const initNativeShell = async () => {
  if (!isNative()) return null;
  document.body.classList.add("capacitor-native");
  const cleanups = [];
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    if (Capacitor.getPlatform() === "ios") {
      // Android system bars are owned by MainActivity and follow the OS theme.
      const { StatusBar, Style } = await import("@capacitor/status-bar");
      await StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
      await StatusBar.setStyle({ style: Style.Default }).catch(() => {});
    }
    await SplashScreen.hide().catch(() => {});
  } catch {
    // Native shell is a progressive enhancement; the web UI stays usable.
  }
  try {
    const { App } = await import("@capacitor/app");
    const listener = await App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack || window.history.length > 1) {
        window.history.back();
      } else {
        App.exitApp();
      }
    });
    cleanups.push(() => listener.remove());
  } catch {
    // Back-button override unavailable; the OS default applies.
  }
  return () => cleanups.forEach((fn) => fn());
};
